import Backbone from 'backbone'
import NavItemList from './collections/nav-item'
import configJSON from '../assets/config.json'
import titles from './titles'

const ConfigModel = Backbone.Model.extend({
    defaults: {
        apps: configJSON.apps,
        api: (typeof API_URL !== 'undefined' && API_URL) ? API_URL : configJSON.api,
        helpLink: configJSON.helpLink,
        navItems: new NavItemList,
        handheld: /iphone|ipod|webos|blackberry|android/.test(window.navigator.userAgent.toLowerCase()),
        id: null,
        slug: '',
        name: '',
        shortName: '',
        titles: null,
        questionData: null,
        testAvailable: false,
        testMode: false,
        scrollPositions: {},
        activeTab: 'all',
        returnRoute: null
    },

    async loadApp(slug) {
        const selectedApp = this.get('apps').find(app => app.slug === slug)
        if (!selectedApp) {
            console.error('App not found')
            return
        }
        try {
            const appConfig = await fetch(`/data/${selectedApp.slug}/config.json`).then(res => res.json())
            const appQuestions = await fetch(`/data/${selectedApp.slug}/question.json`).then(res => res.json())
            this.set({
                id: appConfig.id,
                slug: appConfig.slug,
                name: appConfig.name,
                shortName: appConfig.shortname,
                titles: appConfig.titles,
                questionData: appQuestions,
                testAvailable: false,
                testMode: false,
            })

            this.injectCustomCSS(`/data/${selectedApp.slug}/custom.css`)

            titles.load()
        } catch (err) {
            console.error('Failed to load app config')
        }
    },

    unloadApp() {
        this.set({
            id: null,
            slug: '',
            name: '',
            shortName: '',
            titles: null,
            questionData: null,
            testAvailable: false,
            testMode: false,
        })

        // 2) Clear the titles collection so old models are removed
        titles.reset([])

        // 3) Remove the overrides CSS link if it exists
        const existingLink = document.getElementById('app-custom-css')
        if (existingLink) {
            existingLink.remove()
        }
    },

    injectCustomCSS(cssPath) {
        const existingLink = document.getElementById('app-custom-css')
        if (existingLink) {
            existingLink.remove()
        }

        if (cssPath) {
            const link = document.createElement('link')
            link.id = 'app-custom-css'
            link.rel = 'stylesheet'
            link.href = cssPath
            document.head.appendChild(link)
        }
    }
})

const config = new ConfigModel()

let sequence = []

window.addEventListener('keydown', (event) => {
    if (!event.key) return

    const key = event.key

    if (key === 'd' || key === 'e' || key === 't' || key === 's') {
        sequence.push(key)

        if (sequence.join('') === 'd' + 'd' + 'e' + 't' + 'e' + 's' + 't') {
            config.set('testMode', true)
        }
    } else {
        sequence = []
    }
})

export default config
